/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

export default function () {

		const mobileNavigation = document.querySelector('.mobile-menu-wrapper');
		const desktopNavigation = document.querySelector('.desktop-menu');
		// console.log('siteNavigation', mobileNavigation, desktopNavigation);

		// const mobileSearch = document.querySelector('.site-header__search');
		// const searchToggle = document.getElementById('search-toggle');

		// Return early if the navigation doesn't exist.
		if (!mobileNavigation || !desktopNavigation) {
			return;
		}

		const toggleButton = document.getElementById('menu-toggle');

		// Return early if the button doesn't exist.
		if ('undefined' === typeof toggleButton) {
			return;
		}

		// Hide menu toggle button if menu is empty and return early.
		if ('undefined' === typeof mobileNavigation || !toggleButton) {
			toggleButton.style.display = 'none';
			return;
		}

		// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
		toggleButton.addEventListener('click', function () {
			mobileNavigation.classList.toggle('toggled');
			toggleButton.classList.toggle('toggled');
			document.querySelector('body').classList.toggle('locked');
			if (toggleButton.getAttribute('aria-expanded') === 'true') {
				toggleButton.setAttribute('aria-expanded', 'false');
			} else {
				toggleButton.setAttribute('aria-expanded', 'true');
			}
		});

		// Get all the link elements within the menu.
		// const links = menu.getElementsByTagName('a');

		// Get all the link elements with children within the menu.
		// const linksWithChildren = menu.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');

		// NAV FOR DROPDOWNS
		// MOBILE
		const mobileNavItemsWithSubMenus = mobileNavigation.querySelectorAll('.menu-item-has-children button');
		// console.log('navItemsWithSubMenus', mobileNavItemsWithSubMenus);
		if (mobileNavItemsWithSubMenus.length > 0) {
			mobileNavItemsWithSubMenus.forEach((item) => {
				item.addEventListener('click', function () {
					// if another menu is open, close it
					let clicked = item.parentElement;
					const openMenus = mobileNavigation.querySelectorAll('.menu-item-has-children button[aria-expanded="true"]');
					if (openMenus.length > 0) {
						openMenus.forEach((openMenu) => {
							if (openMenu.parentElement !== clicked) {
								remove(openMenu);
							}
						});
					}
					// open the clicked menu
					if (item.getAttribute('aria-expanded') === 'true') {
						remove(item);
					} else {
						show(item)
					}
				});
			});
			// click outside 
		}
		const desktopNavItemsWithSubMenus = desktopNavigation.querySelectorAll('.menu-item-has-children button');
		const navItemsWholeTree = desktopNavigation.querySelectorAll('ul.menu > li.menu-item-has-children');
		let timer: any = null;
		// console.log('navItemsWithSubMenus', desktopNavItemsWithSubMenus, navItemsWholeTree);
		if (desktopNavItemsWithSubMenus && navItemsWholeTree) {
			navItemsWholeTree.forEach((item) => {
				let button = item.querySelector('button');
				item.addEventListener('mouseover', function () {
					// if another menu is open, close it
					let clicked = item.parentElement;
					const openMenus = desktopNavigation.querySelectorAll('.menu-item-has-children button[aria-expanded="true"]');
					if (openMenus.length > 0) {
						openMenus.forEach((openMenu) => {
							if (openMenu.parentElement !== clicked) {
								remove(openMenu);
							}
						});
					}
					// open the clicked menu
					show(item)
					clearTimeout(timer);
				});
				item.addEventListener('mouseout', function () {
					timer = setTimeout(() => {
						remove(item);
					}, 500);
				});
				item.addEventListener('keydown', function (event) {
					if (event.key === 'Escape') {
						remove(item);
					}
					if (event.key === 'Enter') {
						if (button.getAttribute('aria-expanded') === 'true') {
							remove(item);
						} else {
							show(item)
						}
					}
				});
			});
			// click outside 
		}

		function clickOutsideRemove(event) {
			if (!event.target.closest('.menu-item-has-children')) {
				const openMenusM = mobileNavigation.querySelectorAll('.menu-item-has-children button[aria-expanded="true"]');
				const openMenusD = desktopNavigation.querySelectorAll('.menu-item-has-children button[aria-expanded="true"]');
				// console.log('FFFs', openMenusM);
				if (openMenusM.length > 0) {
					openMenusM.forEach((openMenu) => {
						remove(openMenu);
						document.removeEventListener('click', clickOutsideRemove);
					});
				}
				if (openMenusD.length > 0) {
					openMenusD.forEach((openMenu) => {
						remove(openMenu);
						document.removeEventListener('click', clickOutsideRemove);
					});
				}
			}
		}

		function remove(item) {
			if (item.nodeName === 'BUTTON') {
				item.parentElement.classList.remove('toggled');
				item.setAttribute('aria-expanded', 'false');
			} else {
				let button = item.querySelector('button');
				button.parentElement.classList.remove('toggled');
				button.setAttribute('aria-expanded', 'false');
			}
		}
		function show(item) {
			// if item is a button element
			if (item.nodeName === 'BUTTON') {
				item.parentElement.classList.add('toggled');
				item.setAttribute('aria-expanded', 'true');
			} else {
				let button = item.querySelector('button');
				button.parentElement.classList.add('toggled');
				button.setAttribute('aria-expanded', 'true');
			}
			document.addEventListener('click', clickOutsideRemove);
		}

		// if (mobileSearch && searchToggle) {
		// 	searchToggle.addEventListener('click', function () {
		// 		mobileSearch.classList.toggle('toggled');
		// 		searchToggle.classList.toggle('toggled');
		// 		if (searchToggle.getAttribute('aria-expanded') === 'true') {
		// 			searchToggle.setAttribute('aria-expanded', 'false');
		// 		} else {
		// 			searchToggle.setAttribute('aria-expanded', 'true');
		// 		}
		// 	});
		// }
}